import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import AddEmailConfigModal from "./AddEmailConfigModal";
import {
  dynamicEmailConfigModalStyles,
  defaultModalStyles,
} from "../../../common/CustomModalStyles";
import LoadingSpinner from "../../../LoadingSpinner";
import CommonDeleteModal, {
  DeleteMessageBody,
} from "../../common/CommonDeleteModal";
import {
  useSmtpConfigDeleteMutation,
  useSmtpUserMailConfigsQuery,
} from "../../../../Services/settingsAPIs/EmailConfiguration";

const EmailConfigPane = () => {
  const [isOpenSMTPModal, setIsOpenSMTPModal] = useState(false);
  const [emailConfigForDeletion, setEmailConfigForDeletion] =
    useState<number>();
  const [mailConfigurationsOnDisplay, setMailConfigurationsOnDisplay] =
    useState<any[]>([]);
  const [triggerSMTPConfigDeleteMutation] = useSmtpConfigDeleteMutation();
  const [mailConfigForEdit, setMailConfigForEdit] = useState<any>({
    mailConfigEditEnabled: false,
    mailConfigData: null,
  });
  const [
    isDeleteEmailConfigurationModalOpen,
    setIsDeleteEmailConfigurationModalOpen,
  ] = useState<boolean>(false);

  const user_Role = localStorage.getItem("user_role");

  const {
    data: emailSMTPmailConfigData,
    refetch: refetchSMTPmailConfigData,
    isLoading: isLoadingSMTPmailconfig,
  } = useSmtpUserMailConfigsQuery({});

  const openSMTPConfigModal = () => setIsOpenSMTPModal(true);
  const closeSMTPEmailConfigModal = () => {
    setMailConfigForEdit({
      mailConfigEditEnabled: false,
      mailConfigData: null,
    });
    setIsOpenSMTPModal(false);
  };

  const openDeleteEmailConfigurationModal = () => {
    setIsDeleteEmailConfigurationModalOpen(true);
  };

  const closeDeleteEmailConfigurationModal = () => {
    refetchSMTPmailConfigData();
    setIsDeleteEmailConfigurationModalOpen(false);
  };

  const editModalHandler = (el: any) => {
    setMailConfigForEdit({
      mailConfigEditEnabled: true,
      mailConfigData: {
        id: el.id,
        username: el.username,
        password: el.password,
        host_name: el.host_name,
        port: el.port,
        team: el.team,
        user: el.user,
        email_server: el.email_server,
        client_id: el.client_id,
        client_secret: el.client_secret,
        server_tenant_id: el.server_tenant_id,
      },
    });
    openSMTPConfigModal();
  };

  const deleteModalHandler = (el: any) => {
    setEmailConfigForDeletion(el.id);
    openDeleteEmailConfigurationModal();
  };

  useEffect(() => {
    if (!isLoadingSMTPmailconfig && emailSMTPmailConfigData?.length > 0) {
      setMailConfigurationsOnDisplay(emailSMTPmailConfigData);
    } else {
      setMailConfigurationsOnDisplay([]);
    }
  }, [isLoadingSMTPmailconfig, emailSMTPmailConfigData]);

  return (
    <>
      <div className="d-flex align-items-center" style={{ width: "100%" }}>
        <div style={{ flex: "1" }}>
          <span className="input-group-text mt-2" id="basic-addon1">
            Tenant based configuration (SMTP)
          </span>
        </div>
        <div style={{ paddingLeft: "20px" }}>
          {user_Role === "admin" && (
            <button
              className="input-group-text align-items-center text-hover-primary fw-bold"
              onClick={openSMTPConfigModal}
            >
              <i className="bi bi-plus-lg me-2"></i>
              Add
            </button>
          )}
        </div>
      </div>

      <div className="col">
        <span className="input-group-text mt-2" id="basic-addon1">
          Mail ID
        </span>
      </div>

      {/* Content */}
      {isLoadingSMTPmailconfig ? (
        <div className="d-flex justify-content-center mt-5">
          <LoadingSpinner />
        </div>
      ) : mailConfigurationsOnDisplay.length > 0 ? (
        <div className="mt-4">
          {/* Table Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              background: "#6366f1",
              color: "white",
              alignItems: "center",
              padding: "10px",
              fontSize: "16px",
            }}
          >
            <span>Name</span>
            <span>Action</span>
          </div>

          {/* Table Rows */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            {mailConfigurationsOnDisplay.map((config) => (
              <div
                key={config.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  borderBottom: "1px solid grey",
                }}
              >
                <p style={{ margin: 0 }}>{config.username}</p>
                {user_Role === "admin" && (
                  <p style={{ margin: 0, display: "flex", gap: "20px" }}>
                    <i
                      className="bi bi-pencil fs-4 text-dark text-hover-primary cursor-pointer"
                      aria-label="Edit Item"
                      onClick={() => editModalHandler(config)}
                    />
                    <i
                      className="bi bi-trash fs-4 text-dark text-hover-danger cursor-pointer"
                      aria-label="Delete Item"
                      onClick={() => deleteModalHandler(config)}
                    />
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center mt-5">
          <span>No mail configurations found.</span>
        </div>
      )}

      <ReactModal
        isOpen={isOpenSMTPModal}
        onRequestClose={closeSMTPEmailConfigModal}
        style={dynamicEmailConfigModalStyles}
        contentLabel="SMTP Email Configuration"
        shouldCloseOnOverlayClick={false}
      >
        <AddEmailConfigModal
          closeModal={closeSMTPEmailConfigModal}
          refetch={refetchSMTPmailConfigData}
          mailConfigForEdit={mailConfigForEdit}
        />
      </ReactModal>

      <ReactModal
        isOpen={isDeleteEmailConfigurationModalOpen}
        onRequestClose={closeDeleteEmailConfigurationModal}
        style={defaultModalStyles}
        contentLabel="Delete a selected email configuration"
        shouldCloseOnOverlayClick={false}
      >
        <CommonDeleteModal
          closeModal={closeDeleteEmailConfigurationModal}
          deleteAPItrigger={triggerSMTPConfigDeleteMutation}
          deletionIdentifier={emailConfigForDeletion}
          messageBody={
            <DeleteMessageBody
              bodyParams={{
                descriptionPromptEnabled: false,
                deletionOf: "SMTP tenant based configuration",
              }}
            />
          }
        />
      </ReactModal>
    </>
  );
};

export default EmailConfigPane;
